module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-19@2x-b543de013fdbfeeea3effe87e77a4947.png";